export function filterReviewSessions(sessions = [], query = '') {
  const needle = String(query || '').trim().toLowerCase();
  if (!needle) return sessions;
  return sessions.filter((session) => (
    [
      session.id,
      session.visitorLabel,
      session.pageUrl,
      session.status
    ].join(' ').toLowerCase().includes(needle)
  ));
}

export function getReviewNotes(events = []) {
  return events
    .filter((event) => event.eventType === 'note_saved')
    .map((event) => ({
      id: event.id,
      section: event.section || event.metadata?.note?.section || 'Overall page',
      text: event.message || event.metadata?.note?.text || '',
      path: event.metadata?.path || event.metadata?.note?.path || '',
      createdAt: event.createdAt
    }))
    .filter((note) => note.text);
}

export function getReviewChat(events = []) {
  return events
    .filter((event) => event.eventType === 'chat_message')
    .map((event) => ({
      id: event.id,
      role: event.role === 'assistant' ? 'assistant' : 'user',
      section: event.section || 'Overall page',
      text: event.message || '',
      createdAt: event.createdAt
    }))
    .filter((message) => message.text);
}

export function summarizeReviewSessions(sessions = [], events = []) {
  const notes = getReviewNotes(events);
  const chat = getReviewChat(events);
  const totalEvents = sessions.reduce((sum, session) => sum + Number(session.eventCount || 0), 0);
  return {
    sessions: sessions.length,
    totalEvents,
    currentNotes: notes.length,
    currentChatTurns: chat.length
  };
}

export function buildWireframeChangeBrief(session = {}, events = []) {
  const notes = getReviewNotes(events);
  const chat = getReviewChat(events);
  const lines = [
    '# Chetzels Wireframe Review',
    '',
    `Session: ${session.id || 'Unknown session'}`,
    `Reviewer: ${session.visitorLabel || 'Karina'}`,
    `Last updated: ${session.lastSeenAt || 'Unknown'}`,
    session.pageUrl ? `Page: ${session.pageUrl}` : '',
    '',
    '## Saved Change Notes'
  ];

  if (!notes.length) {
    lines.push('- No saved notes yet.');
  } else {
    const grouped = groupNotesBySection(notes);
    Object.entries(grouped).forEach(([section, sectionNotes]) => {
      lines.push(`### ${section}`);
      sectionNotes.forEach((note) => {
        lines.push(`- ${note.text}${note.path ? ` (${note.path})` : ''}`);
      });
    });
  }

  lines.push('', '## Chat Transcript');
  if (!chat.length) {
    lines.push('- No chat messages yet.');
  } else {
    chat.forEach((message) => {
      lines.push(`- ${titleRole(message.role)} [${message.section}]: ${message.text}`);
    });
  }

  return lines.join('\n').trim();
}

function groupNotesBySection(notes) {
  return notes.reduce((groups, note) => {
    const section = note.section || 'Overall page';
    if (!groups[section]) groups[section] = [];
    groups[section].push(note);
    return groups;
  }, {});
}

function titleRole(role) {
  return role === 'assistant' ? 'Assistant' : 'Karina';
}
